export default __webpack_public_path__ + "media/assets/img/img_icon_subtitle-568d0af2db8c1d5719e152b6a7887865.svg";